import { IAMPermission } from '@sgwt/react-shared-libs';
import { IBaseEntity, ProfileType } from '.';

const IAM_RESOURCE = 'api.modernization';

export const UserPermissions: Record<string, IAMPermission> = {
  ADMIN: { resource: IAM_RESOURCE, permission: 'Administrator', resourceId: undefined, constraints: [] },
  MODERATOR: { resource: IAM_RESOURCE, permission: 'Moderator', resourceId: undefined, constraints: [] },
  AUDITOR: { resource: IAM_RESOURCE, permission: 'Auditor', resourceId: undefined, constraints: [] },
  REVIEWER: { resource: IAM_RESOURCE, permission: 'Reviewer', resourceId: undefined, constraints: [] },
  ARCHITECT: { resource: IAM_RESOURCE, permission: 'Architect', resourceId: undefined, constraints: [] },
};

export interface IUser extends IBaseEntity {
  email: string;
  resetLocaleStorage: boolean;
  profileType: ProfileType | null;
  notificationLevel: string;
}

export interface IUserUpdate {
  resetLocaleStorage?: boolean;
  profileType?: ProfileType | null;
}

export interface IResponseUser extends IBaseEntity {
  users: IUser[];
}

export type UserNotificationLabels = Record<string, string>;
